<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="col-12 bg-primary py-3  text-center" >
                <template #default>   <m-h5 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>بازیابی رمز عبور   </template>
                </m-h5></template>
                </m-div><m-forget-password-1 v-bind='{...{"image":null},...{}}' :style='""' class="authentication-forms" ></m-forget-password-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH5 from '@moeinmdn/miw-alpha-components/src/package/Tags/H5'; import mForgetPassword1 from '@moeinmdn/miw-alpha-components/src/package/Authentication/ForgetPassword/ForgetPassword1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH5,mForgetPassword1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
